/* XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX */
/* AUTO-GENERATED; DO NOT EDIT! (edit routegen.js instead) */
/* XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX */

import AboutUs from "./p/AboutUs";
import BeginnersGuide from "./p/BeginnersGuide";
import Callback from "./p/Callback";
import Contact from "./p/Contact";
import Cookies from "./p/Cookies";
import EditGame from "./p/EditGame";
import ExploreCOMM from "./p/ExploreCOMM";
import ExploreCPH from "./p/ExploreCPH";
import ExploreCRYPTO from "./p/ExploreCRYPTO";
import ExploreETF from "./p/ExploreETF";
import ExploreFUND from "./p/ExploreFUND";
import ExploreHEL from "./p/ExploreHEL";
import ExploreICE from "./p/ExploreICE";
import ExploreIndexes from "./p/ExploreIndexes";
import ExploreMarkets from "./p/ExploreMarkets";
import ExploreSTO from "./p/ExploreSTO";
import ExploreUS from "./p/ExploreUS";
import ExploreWBAG from "./p/ExploreWBAG";
import ExploreXETRA from "./p/ExploreXETRA";
import FAQ from "./p/FAQ";
import FlaggedPortfolios from "./p/FlaggedPortfolios";
import FullGroupLeaderboard from "./p/FullGroupLeaderboard";
import FullLeaderboard from "./p/FullLeaderboard";
import Game from "./p/Game";
import GroupInvitePage from "./p/GroupInvitePage";
import InvitePage from "./p/InvitePage";
import Logout from "./p/Logout";
import Notifications from "./p/Notifications";
import Partners from "./p/Partners";
import Portfolio from "./p/Portfolio";
import Preferences from "./p/Preferences";
import PrivacyPolicy from "./p/PrivacyPolicy";
import RenderOpenGraphTicker from "./p/RenderOpenGraphTicker";
import TermsOfUse from "./p/TermsOfUse";
import Ticker from "./p/Ticker";
import TradeHistory from "./p/TradeHistory";
import Unsubscribe from "./p/Unsubscribe";
import UserReports from "./p/UserReports";

import { Main, MainNoNagbox } from "./Main";
import { Home, Welcome } from "./p/Home";
import { DefaultLeaderboard } from "./p/Leaderboard";

export default {
	"/": {
		"": Home,
		"/callback": Callback,
		"/edit_game/:game_id": EditGame,
		"/explore": ExploreMarkets,
		"/explore-commodities": ExploreCOMM,
		"/explore-cph": ExploreCPH,
		"/explore-crypto": ExploreCRYPTO,
		"/explore-etfs": ExploreETF,
		"/explore-funds": ExploreFUND,
		"/explore-hel": ExploreHEL,
		"/explore-ice": ExploreICE,
		"/explore-indexes": ExploreIndexes,
		"/explore-sto": ExploreSTO,
		"/explore-us": ExploreUS,
		"/explore-vie": ExploreWBAG,
		"/explore-xetra": ExploreXETRA,
		"/flagged_portfolios": FlaggedPortfolios,
		"/game/:game_id": Game,
		"/group/invite/:group_id": GroupInvitePage,
		"/group/invite/:group_id/:invite_key": GroupInvitePage,
		"/group_leaderboard_full/:group_id": FullGroupLeaderboard,
		"/invite/:game_id": InvitePage,
		"/invite/:game_id/:invite_key": InvitePage,
		"/leaderboard_full": FullLeaderboard,
		"/logout": Logout,
		"/notifications": Notifications,
		"/portfolio/:portfolio_id": Portfolio,
		"/preferences": Preferences,
		"/ticker/:exchange/:ticker": Ticker,
		"/trade_history": TradeHistory,
		"/unsub": Unsubscribe,
		"/user_reports": UserReports,
		"/welcome": Welcome,
		container: Main,
	},
	"/_render": {
		"/opengraph": {
			"/ticker/:exchange/:ticker": RenderOpenGraphTicker,
		},
	},
	"/about": {
		"": AboutUs,
		container: MainNoNagbox,
	},
	"/contact": {
		"": Contact,
		container: MainNoNagbox,
	},
	"/cookies": {
		"": Cookies,
		container: MainNoNagbox,
	},
	"/equity-abc": {
		"": BeginnersGuide,
		container: MainNoNagbox,
	},
	"/faq": {
		"": FAQ,
		container: MainNoNagbox,
	},
	"/leaderboard": {
		"/:data_key": DefaultLeaderboard,
	},
	"/partners": {
		"": Partners,
		container: MainNoNagbox,
	},
	"/privacy": {
		"": PrivacyPolicy,
		container: MainNoNagbox,
	},
	"/termsofuse": {
		"": TermsOfUse,
		container: MainNoNagbox,
	},
};



// WEBPACK FOOTER //
// ./src/routes.autogen.js